import { render, staticRenderFns } from "./comments-modal.vue?vue&type=template&id=1ed0f972"
import script from "./comments-modal.vue?vue&type=script&lang=js"
export * from "./comments-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports